const rankingItems = [
  { rank: 1, title: '长相思', heat: '9856万', trend: 'up', genre: '古装神话', change: '+2' },
  { rank: 2, title: '莲花楼', heat: '8723万', trend: 'up', genre: '武侠探案', change: '+5' },
  { rank: 3, title: '长风渡', heat: '7641万', trend: 'stable', genre: '古装商战', change: '—' },
  { rank: 4, title: '七时吉祥', heat: '6982万', trend: 'up', genre: '仙侠爱情', change: '+8' },
  { rank: 5, title: '偷偷藏不住', heat: '6234万', trend: 'down', genre: '青春暗恋', change: '-1' },
  { rank: 6, title: '玉骨遥', heat: '5891万', trend: 'up', genre: '仙侠巨制', change: '+3' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center">
          热播榜单
        </h2>
        <p className="mt-2 text-sm text-foreground-500 text-center">
          实时热度排行，追剧风向标
        </p>
        <div className="mt-10 space-y-3">
          {rankingItems.map((item, i) => (
            <div
              key={i}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200/50 transition-colors cursor-pointer"
            >
              <span
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-secondary-100 text-secondary-700'
                }`}
              >
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900">{item.title}</h3>
                <p className="text-xs text-foreground-500">{item.genre}</p>
              </div>
              <div className="text-right flex-shrink-0">
                <p className="text-sm font-bold text-accent-600">
                  {item.rank <= 3 && <i className="ri-fire-fill mr-0.5"></i>}
                  {item.heat}
                </p>
                <p className={`text-xs font-medium ${
                  item.trend === 'up' ? 'text-primary-500' : item.trend === 'down' ? 'text-foreground-400' : 'text-foreground-500'
                }`}>
                  {item.trend === 'up' && <i className="ri-arrow-up-line mr-0.5"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line mr-0.5"></i>}
                  {item.change}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}